import * as ARTICLE_ACTION from 'constant/action/article'
import { handleActions } from 'redux-actions'

const initialState = {
  article: {},
  articleDescription: '',
  articles: {},
  attachments: {},
  attachmentsPagination: {},
  authors: null,
  exportData: [],
  latestArticles: [],
  loadingAttachments: false,
  newAttachmentFileList: [],
  pagination: {},
  previewArticles: {},
  previewCategory: '',
  searchTerm: '',
  subCategoryFilterValue: '',
  templates: []
}

export default handleActions(
  {
    [ARTICLE_ACTION.UPDATE_ARTICLES]: (state, action) => ({
      ...state,
      articles: action.payload
    }),
    [ARTICLE_ACTION.UPDATE_ARTICLE]: (state, action) => ({
      ...state,
      article: action.payload
    }),
    [ARTICLE_ACTION.UPDATE_PREVIEW_ARTICLES]: (state, action) => ({
      ...state,
      previewArticles: action.payload
    }),
    [ARTICLE_ACTION.UPDATE_LATEST_ARTICLES]: (state, action) => ({
      ...state,
      latestArticles: action.payload
    }),
    [ARTICLE_ACTION.UPDATE_ARTICLE_PAGINATION]: (state, action) => ({
      ...state,
      pagination: action.payload
    }),
    [ARTICLE_ACTION.UPDATE_ATTACHMENTS]: (state, action) => ({
      ...state,
      attachments: { ...state.attachments, ...action.payload }
    }),
    [ARTICLE_ACTION.UPDATE_LOADING_ATTACHMENTS]: (state, action) => ({
      ...state,
      loadingAttachments: action.payload
    }),
    [ARTICLE_ACTION.UPDATE_ATTACHMENT_PAGINATION]: (state, action) => ({
      ...state,
      attachmentsPagination: action.payload
    }),
    [ARTICLE_ACTION.UPDATE_NEW_ATTACHMENT_FILE_LIST]: (state, action) => ({
      ...state,
      newAttachmentFileList: action.payload
    }),
    [ARTICLE_ACTION.UPDATE_ARTICLE_DESCRIPTION]: (state, action) => ({
      ...state,
      articleDescription: action.payload
    }),
    [ARTICLE_ACTION.UPDATE_PREVIEW_CATEGORY]: (state, action) => ({
      ...state,
      previewCategory: action.payload
    }),
    [ARTICLE_ACTION.UPDATE_SUB_CATEGORY_FILTER]: (state, action) => ({
      ...state,
      subCategoryFilterValue: action.payload
    }),
    [ARTICLE_ACTION.UPDATE_EXPORT_DATA]: (state, action) => ({
      ...state,
      exportData: action.payload
    }),
    [ARTICLE_ACTION.UPDATE_ARTICLE_SEARCH_TERM]: (state, action) => ({
      ...state,
      searchTerm: action.payload
    }),
    [ARTICLE_ACTION.UPDATE_TEMPLATES]: (state, action) => ({
      ...state,
      templates: action.payload
    }),
    [ARTICLE_ACTION.UPDATE_ARTICLE_AUTHORS]: (state, action) => ({
      ...state,
      authors: action.payload
    })
  },
  initialState
)
